import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import Blog1Img from "../../assest/Blog-1.png";
import Blog2Img from "../../assest/Blog-2.png";
import Blog3Img from "../../assest/Blog-3.png";
import Arrow from "../../assest/arrow.png";
import { FaUser, FaTag } from "react-icons/fa";

const Blogs = () => {
  const { language } = useSelector((state) => state.language);

  const translations = {
    gb: {
      heading: "Read Our Latest Blogs",
      admin: "Admin",
      category: "Technology",
      posts: [
        {
          title: "Essential Safety Protocols For Construction",
          snippet: "Explore innovative methods transforming the construction industry.",
        },
        {
          title: "Sustainable Building Materials",
          snippet: "How eco-friendly materials can reduce your carbon footprint.",
        },
        {
          title: "Project Management Tips",
          snippet: "Effective strategies to keep your construction projects on track.",
        },
      ],
      readMore: "Read More",
      viewAll: "View All",
    },
    sa: {
      heading: "اقرأ أحدث مدوناتنا",
      admin: "المشرف",
      category: "التكنولوجيا",
      posts: [
        {
          title: "بروتوكولات السلامة الأساسية للبناء",
          snippet: "استكشف الطرق المبتكرة التي تحول صناعة البناء.",
        },
        {
          title: "مواد البناء المستدامة",
          snippet: "كيف يمكن للمواد الصديقة للبيئة تقليل بصمتك الكربونية.",
        },
        {
          title: "نصائح إدارة المشاريع",
          snippet: "استراتيجيات فعالة للحفاظ على مشاريع البناء في المسار الصحيح.",
        },
      ],
      readMore: "اقرأ المزيد",
      viewAll: "عرض الكل",
    },
    fr: {
      heading: "Lisez nos derniers blogs",
      admin: "Administrateur",
      category: "Technologie",
      posts: [
        {
          title: "Protocoles de sécurité essentiels pour la construction",
          snippet: "Découvrez les méthodes innovantes qui transforment l'industrie de la construction.",
        },
        {
          title: "Matériaux de construction durables",
          snippet: "Comment les matériaux écologiques peuvent réduire votre empreinte carbone.",
        },
        {
          title: "Conseils de gestion de projet",
          snippet: "Stratégies efficaces pour garder vos projets de construction sur la bonne voie.",
        },
      ],
      readMore: "Lire la suite",
      viewAll: "Voir tout",
    },
    de: {
      heading: "Lesen Sie unsere neuesten Blogs",
      admin: "Admin",
      category: "Technologie",
      posts: [
        {
          title: "Wesentliche Sicherheitsprotokolle für den Bau",
          snippet: "Entdecken Sie innovative Methoden, die die Bauindustrie verändern.",
        },
        {
          title: "Nachhaltige Baumaterialien",
          snippet: "Wie umweltfreundliche Materialien Ihren CO2-Fußabdruck reduzieren können.",
        },
        {
          title: "Tipps für Projektmanagement",
          snippet: "Effektive Strategien, um Ihre Bauprojekte auf Kurs zu halten.",
        },
      ],
      readMore: "Mehr lesen",
      viewAll: "Alle anzeigen",
    },
  };

  const t = translations[language] || translations.gb;

  const blogPosts = [
    {
      img: Blog1Img,
      date: "28 June",
      admin: t.admin,
      category: t.category,
      title: t.posts[0].title,
      snippet: t.posts[0].snippet,
    },
    {
      img: Blog2Img,
      date: "28 June",
      admin: t.admin,
      category: t.category,
      title: t.posts[1].title,
      snippet: t.posts[1].snippet,
    },
    {
      img: Blog3Img,
      date: "28 June",
      admin: t.admin,
      category: t.category,
      title: t.posts[2].title,
      snippet: t.posts[2].snippet,
    },
  ];

  return (
    <div className="container py-5">
      {/* Heading */}
      <h2 className="text-center fw-bold mb-4">
        {t.heading}
        <div className="d-flex justify-content-center">
          <div style={{ width: "40px", height: "3px", backgroundColor: "#c8102e", marginTop: "8px" }}></div>
          <div style={{ width: "5px", height: "3px", backgroundColor: "#c8102e", margin: "8px 4px 0 4px" }}></div>
          <div style={{ width: "40px", height: "3px", backgroundColor: "#c8102e", marginTop: "8px" }}></div>
        </div>
      </h2>

      {/* Blog cards */}
      <div className="row g-4 mb-4">
        {blogPosts.map(({ img, date, admin, category, title }, i) => (
          <div key={i} className="col-md-4">
            <Link to="/blogs-Team" className="text-decoration-none text-dark">
              <div className="card h-100 shadow-sm position-relative overflow-hidden">
                {/* Date badge */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "0px",
                    backgroundColor: "white",
                    color: "#c8102e",
                    padding: "12px 12px",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                    zIndex: 10,
                    userSelect: "none",
                    boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                  }}
                >
                  {date}
                </div>

                {/* Image */}
                <img
                  src={img}
                  className="card-img-top"
                  alt={title}
                  style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                  }}
                />

                {/* Info section */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    backgroundColor: "white",
                    padding: "15px 20px",
                    boxSizing: "border-box",
                  }}
                >
                  {/* Admin + Category with Icons */}
                  <div className="d-flex align-items-center mb-1 gap-3">
                    <span className="d-flex align-items-center gap-1 text-danger">
                      <FaUser /> {admin}
                    </span>
                    <span className="d-flex align-items-center gap-1 text-danger fst-italic">
                      <FaTag /> {category}
                    </span>
                  </div>

                  {/* Title */}
                  <h5 className="card-title fw-bold mb-2">{title}</h5>

                  {/* Read More Button */}
                  <button
                    className="btn btn-link p-0 d-flex align-items-center"
                    style={{
                      fontWeight: "600",
                      fontSize: "0.95rem",
                      color: "#c8102e",
                      cursor: "pointer",
                      gap: "6px",
                    }}
                  >
                    {t.readMore}
                    <img
                      src={Arrow}
                      alt="arrow"
                      className="arrow-icon"
                      style={{
                        width: "16px",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </button>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* View All Button */}
      <div className="text-center">
        <button className="btn btn-danger rounded-pill px-5 py-2 shadow d-flex align-items-center mx-auto" style={{ gap: "8px" }}>
          {t.viewAll}
          <img src={Arrow} alt="arrow" style={{ width: "30px" }} />
        </button>
      </div>

      {/* Hover effect for arrow */}
      <style>{`
        .btn-link:hover .arrow-icon {
          transform: translateX(5px);
        }
      `}</style>
    </div>
  );
};

export default Blogs;